var _style, _g, _circle, _polygon, _polygon2, _polygon3, _ellipse, _ellipse2, _path, _path2, _path3, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _rect, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _path4, _g22, _g23, _path5, _path6, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternetmarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.5;fill:#E0D7E8;enable-background:new    ;}\r\n\t.st1{opacity:0.17;fill:url(#SVGID_1_);enable-background:new    ;}\r\n\t.st2{opacity:0.17;fill:url(#SVGID_2_);enable-background:new    ;}\r\n\t.st3{opacity:0.17;fill:url(#SVGID_3_);enable-background:new    ;}\r\n\t.st4{fill:#E7E4FC;}\r\n\t.st5{fill:#BFD0FC;}\r\n\t.st6{fill:url(#SVGID_4_);}\r\n\t.st7{fill:#F1F1F1;}\r\n\t.st8{fill:#777777;}\r\n\t.st9{fill:#E9EDFD;}\r\n\t.st10{fill:#333333;}\r\n\t.st11{fill:#69B9EF;}\r\n\t.st12{fill:#FFFFFF;}\r\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:#69B9EF;}\r\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:#E9B34D;}\r\n\t.st15{fill:#497DB3;}\r\n\t.st16{fill:#D05433;}\r\n\t.st17{fill:#A52B31;}\r\n\t.st18{fill:#F7EC41;}\r\n\t.st19{fill:#90D677;}\r\n\t.st20{fill:#E9A42B;}\r\n\t.st21{fill:none;}\r\n\t.st22{fill:#5752B6;}\r\n\t.st23{fill:#625DB5;}\r\n\t.st24{fill:#E1E5FD;}\r\n\t.st25{fill:#353389;}\r\n\t.st26{fill:#C4E6F1;}\r\n\t.st27{fill:#B92F14;}\r\n\t.st28{fill:#D7D5F7;}\r\n\t.st29{font-family:'Arial-BoldMT';}\r\n\t.st30{font-size:30.6919px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 403.94,
    cy: 60.6,
    r: 43.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 171.6318,
    cy: 338.418,
    r: 173.5006,
    gradientTransform: "matrix(0.9895 0.0105 -0.0105 -0.9895 5.3337 508.6675)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5070FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0359,
    style: {
      stopColor: "#4A69F0",
      stopOpacity: 0.9641
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1654,
    style: {
      stopColor: "#3851BF",
      stopOpacity: 0.8346
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2983,
    style: {
      stopColor: "#293C95",
      stopOpacity: 0.7017
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    style: {
      stopColor: "#1C2C73",
      stopOpacity: 0.5675
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5683,
    style: {
      stopColor: "#131F58",
      stopOpacity: 0.4317
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0C1545",
      stopOpacity: 0.2935
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8485,
    style: {
      stopColor: "#07103A",
      stopOpacity: 0.1515
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#060E36",
      stopOpacity: 0
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "37.99,346.56 2.1,310.67 305.23,4.65 341.12,40.55  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 260.2393,
    cy: 247.6655,
    r: 313.2989,
    gradientTransform: "matrix(0.9895 0.0105 -0.0105 -0.9895 5.3337 508.6675)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5070FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214,
    style: {
      stopColor: "#4C6BF4",
      stopOpacity: 0.9786
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1359,
    style: {
      stopColor: "#3B52BB",
      stopOpacity: 0.8641
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2539,
    style: {
      stopColor: "#2B3C89",
      stopOpacity: 0.7461
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3728,
    style: {
      stopColor: "#1E2A5F",
      stopOpacity: 0.6272
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4928,
    style: {
      stopColor: "#131B3D",
      stopOpacity: 0.5072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6143,
    style: {
      stopColor: "#0B0F22",
      stopOpacity: 0.3857
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7378,
    style: {
      stopColor: "#05070F",
      stopOpacity: 0.2622
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8646,
    style: {
      stopColor: "#010204",
      stopOpacity: 0.1354
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "62.17,574.21 -47.63,464.42 458.31,-41.54 568.11,68.26  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 344.5992,
    cy: 163.3005,
    r: 168.8183,
    gradientTransform: "matrix(0.9895 0.0105 -0.0105 -0.9895 5.3337 508.6675)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5070FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214,
    style: {
      stopColor: "#4C6BF4",
      stopOpacity: 0.9786
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1359,
    style: {
      stopColor: "#3B52BB",
      stopOpacity: 0.8641
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2539,
    style: {
      stopColor: "#2B3C89",
      stopOpacity: 0.7461
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3728,
    style: {
      stopColor: "#1E2A5F",
      stopOpacity: 0.6272
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4928,
    style: {
      stopColor: "#131B3D",
      stopOpacity: 0.5072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6143,
    style: {
      stopColor: "#0B0F22",
      stopOpacity: 0.3857
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7378,
    style: {
      stopColor: "#05070F",
      stopOpacity: 0.2622
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8646,
    style: {
      stopColor: "#010204",
      stopOpacity: 0.1354
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "214.85,516.35 178.95,480.46 474.36,185.05 510.25,220.94  "
  })), /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 104.42,
    cy: 432.63,
    rx: 71.63,
    ry: 6.96
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 432.24,
    cy: 425.66,
    rx: 55.22,
    ry: 6.96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M374.04,366.96h86.56c0,0,16.91-18.9,2.98-32.83c-9.77-9.77-19.9-5.97-25.87-12.93s0-26.86-24.87-24.87 s-11.94,34.82-20.89,37.81C382.99,337.12,357.12,344.08,374.04,366.96z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.56,75.13h-18.9c-11.91,0-21.76,9.23-22.78,20.89h-1.59c-6.84,0-12.44,5.6-12.44,12.44 s5.6,12.44,12.44,12.44h24.37h5.47h13.43c12.59,0,22.88-10.3,22.88-22.88l0,0C295.44,85.42,285.14,75.13,272.56,75.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.34,
    y1: 232.385,
    x2: 330.91,
    y2: 232.385,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5C5C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1806,
    style: {
      stopColor: "#3C3C3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5755,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7808,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78.34,355.61c0,4.17,3.41,7.58,7.58,7.58h237.41c4.17,0,7.58-3.41,7.58-7.58V207.62 c0-4.17-3.41-7.58-7.58-7.58H85.92c-4.17,0-7.58,3.41-7.58,7.58V355.61z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.42,
    y: 212.53,
    className: "st7",
    width: 228.4,
    height: 138.17
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M83.19,363.09l-27.92,25.39h297.88l-32.94-24.89C320.21,363.59,153.86,363.09,83.19,363.09z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M310.37,366.6l23.71,16.65H77.52l20.74-17.31C98.26,365.94,308.1,366.6,310.37,366.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.26,
    y: 388.47,
    className: "st10",
    width: 297.88,
    height: 7.9
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.42,
    y: 212.53,
    className: "st11",
    width: 228.4,
    height: 13.23
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 103.51,
    y: 231.46,
    className: "st5",
    width: 96.93,
    height: 49.04
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 110.8,
    y: 240.03,
    className: "st12",
    width: 27.98,
    height: 27.98
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 137.07,
    y: 306.14,
    className: "st13",
    width: 85.6,
    height: 30.99
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "User_12_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 142.73,
    y: 313.21,
    className: "st12",
    width: 64,
    height: 4.95
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "User_13_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 142.73,
    y: 322.63,
    className: "st12",
    width: 49.52,
    height: 4.95
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 106.9,
    y: 306.14,
    className: "st14",
    width: 30.5,
    height: 30.99
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M113.26,316.91c0.51-0.5,1.33-0.5,1.83,0l7.72,6.83l7.72-6.83c0.51-0.5,1.33-0.5,1.83,0 c0.51,0.51,0.51,1.33,0,1.83l-8.62,7.62c-0.26,0.26-0.6,0.38-0.93,0.38c-0.34,0.01-0.67-0.12-0.93-0.37l-8.62-7.62 C112.75,318.24,112.75,317.41,113.26,316.91z"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Schloss_9_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 154.34,
    y: 283.19,
    className: "st11",
    width: 66.33,
    height: 14.59
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Schloss_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 154.34,
    y: 265.12,
    className: "st15",
    width: 66.33,
    height: 14.59
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 220.67,
    y: 265.29,
    className: "st12",
    width: 14.59,
    height: 14.59
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M231.38,274.64c0.15,0.15,0.15,0.4,0,0.56l-1.3,1.3c-0.15,0.15-0.4,0.15-0.56,0l-1.73-1.73 l-1.73,1.73c-0.15,0.15-0.4,0.15-0.56,0l-1.3-1.3c-0.15-0.15-0.15-0.4,0-0.56l1.73-1.73l-1.73-1.73 c-0.15-0.15-0.15-0.4,0-0.56l1.3-1.3c0.15-0.15,0.4-0.15,0.56,0l1.73,1.73l1.73-1.73c0.15-0.15,0.4-0.15,0.56,0l1.3,1.3 c0.15,0.15,0.15,0.4,0,0.56l-1.73,1.73L231.38,274.64z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 220.67,
    y: 283.19,
    className: "st12",
    width: 14.59,
    height: 14.59
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M232.57,288.3l-1.06-1.08c-0.13-0.13-0.33-0.13-0.45,0l-4.4,4.51l-1.87-1.92 c-0.13-0.13-0.33-0.13-0.45,0l-1.06,1.08c-0.13,0.13-0.13,0.34,0,0.46l3.15,3.23c0.06,0.06,0.14,0.1,0.23,0.1 s0.16-0.03,0.23-0.1l5.68-5.82c0.06-0.06,0.09-0.14,0.09-0.23C232.67,288.44,232.63,288.36,232.57,288.3L232.57,288.3z"
  })))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M102.86,218.72c0,1.95-1.58,3.53-3.53,3.53s-3.53-1.58-3.53-3.53s1.58-3.53,3.53-3.53 S102.86,216.77,102.86,218.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M114.05,218.72c0,1.95-1.58,3.53-3.53,3.53s-3.53-1.58-3.53-3.53s1.58-3.53,3.53-3.53 S114.05,216.77,114.05,218.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M125.25,218.72c0,1.95-1.58,3.53-3.53,3.53s-3.53-1.58-3.53-3.53s1.58-3.53,3.53-3.53 S125.25,216.77,125.25,218.72z"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 238.68,
    y: 272.89,
    className: "st12",
    width: 70.14,
    height: 67.16
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M247.11,305.24c0,16.19,13.17,29.36,29.36,29.36s29.36-13.17,29.36-29.36 c0-16.19-13.17-29.36-29.36-29.36C260.28,275.88,247.11,289.05,247.11,305.24z M251.25,305.24 c0-13.91,11.31-25.23,25.22-25.23s25.22,11.32,25.22,25.23s-11.32,25.23-25.22,25.23 C262.56,330.47,251.25,319.15,251.25,305.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M269.43,292.05v26.7c0,0.84,0.5,1.59,1.27,1.91s1.66,0.15,2.25-0.45l13.35-13.35 c0.39-0.39,0.6-0.92,0.6-1.46c0-0.55-0.21-1.08-0.6-1.46l-13.35-13.34c-0.4-0.4-0.92-0.61-1.46-0.61 c-0.27,0-0.54,0.06-0.8,0.16C269.94,290.46,269.43,291.22,269.43,292.05z"
  })))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 390.95,
    y1: 315.23,
    x2: 366.77,
    y2: 339.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M366.77,340.91c-0.38,0-0.77-0.15-1.06-0.44c-0.58-0.58-0.58-1.53,0-2.12l24.18-24.18 c0.58-0.58,1.53-0.58,2.12,0c0.58,0.58,0.58,1.53,0,2.12l-24.18,24.18C367.54,340.76,367.15,340.91,366.77,340.91z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 371.05,
    y1: 319.21,
    x2: 346.87,
    y2: 343.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M346.87,344.89c-0.38,0-0.77-0.15-1.06-0.44c-0.58-0.58-0.58-1.53,0-2.12l24.18-24.18 c0.58-0.58,1.53-0.58,2.12,0c0.58,0.58,0.58,1.53,0,2.12l-24.18,24.18C347.64,344.74,347.26,344.89,346.87,344.89z"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M45.46,275.95c-0.57,0-1.15-0.22-1.59-0.66c-0.88-0.88-0.88-2.3,0-3.17l2.12-2.12 c0.88-0.88,2.3-0.88,3.17,0c0.88,0.88,0.88,2.3,0,3.17l-2.12,2.12C46.61,275.73,46.03,275.95,45.46,275.95z M54.98,266.43 c-0.57,0-1.15-0.22-1.59-0.66c-0.88-0.88-0.88-2.3,0-3.17l2.12-2.12c0.88-0.88,2.3-0.88,3.17,0c0.88,0.88,0.88,2.3,0,3.17 l-2.12,2.12C56.13,266.21,55.55,266.43,54.98,266.43z M64.5,256.91c-0.57,0-1.15-0.22-1.59-0.66c-0.88-0.88-0.88-2.3,0-3.17 l2.12-2.12c0.88-0.88,2.3-0.88,3.17,0c0.88,0.88,0.88,2.3,0,3.17l-2.12,2.12C65.65,256.69,65.07,256.91,64.5,256.91z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 113.83,
    y1: 131.33,
    x2: 138.01,
    y2: 107.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M113.83,132.83c-0.38,0-0.77-0.15-1.06-0.44c-0.58-0.58-0.58-1.53,0-2.12l24.18-24.18 c0.58-0.58,1.53-0.58,2.12,0c0.58,0.58,0.58,1.53,0,2.12l-24.18,24.18C114.59,132.68,114.21,132.83,113.83,132.83z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M133.84,132.66c-0.57,0-1.15-0.22-1.59-0.66c-0.88-0.88-0.88-2.3,0-3.17l2.12-2.12 c0.88-0.88,2.3-0.88,3.17,0c0.88,0.88,0.88,2.3,0,3.17l-2.12,2.12C134.99,132.44,134.42,132.66,133.84,132.66z M143.36,123.14 c-0.57,0-1.15-0.22-1.59-0.66c-0.88-0.88-0.88-2.3,0-3.17l2.12-2.12c0.88-0.88,2.3-0.88,3.17,0c0.88,0.88,0.88,2.3,0,3.17 l-2.12,2.12C144.51,122.92,143.94,123.14,143.36,123.14z M152.88,113.62c-0.57,0-1.15-0.22-1.59-0.66 c-0.88-0.88-0.88-2.3,0-3.17l2.12-2.12c0.88-0.88,2.3-0.88,3.17,0c0.88,0.88,0.88,2.3,0,3.17l-2.12,2.12 C154.03,113.4,153.46,113.62,152.88,113.62z M162.4,104.1c-0.57,0-1.15-0.22-1.59-0.66c-0.88-0.88-0.88-2.3,0-3.17l2.12-2.12 c0.88-0.88,2.3-0.88,3.17,0c0.88,0.88,0.88,2.3,0,3.17l-2.12,2.12C163.55,103.88,162.98,104.1,162.4,104.1z M171.92,94.58 c-0.57,0-1.15-0.22-1.59-0.66c-0.88-0.88-0.88-2.3,0-3.17l2.12-2.12c0.88-0.88,2.3-0.88,3.17,0c0.88,0.88,0.88,2.3,0,3.17 l-2.12,2.12C173.07,94.36,172.5,94.58,171.92,94.58z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M241.74,168.04l-2.99-0.19l0.47-7.43l-7.34,0.54l-0.22-2.98l9.05-0.67c0.45-0.04,0.86,0.12,1.16,0.43 c0.31,0.3,0.47,0.73,0.44,1.16L241.74,168.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.55,
    y: 168.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -53.1656 212.2357)",
    className: "st22",
    width: 32.12,
    height: 2.99
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M210.93,142.07c0.99,0.99,2.6,0.99,3.59,0c0.99-0.99,0.99-2.6,0-3.59l-2.37-2.37 c-0.99-0.99-2.6-0.99-3.59,0c-0.99,0.99-0.99,2.6,0,3.59L210.93,142.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M211.16,145.11l-2.37,2.37c-0.99,0.99-0.99,2.6,0,3.59c0.99,0.99,2.6,0.99,3.59,0l2.37-2.37 c0.99-0.99,0.99-2.6,0-3.59C213.76,144.12,212.15,144.12,211.16,145.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M221.29,142.07l2.37-2.37c0.99-0.99,0.99-2.6,0-3.59c-0.99-0.99-2.6-0.99-3.59,0l-2.37,2.37 c-0.99,0.99-0.99,2.6,0,3.59S220.29,143.06,221.29,142.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M221.05,145.11c-0.99-0.99-2.6-0.99-3.59,0c-0.99,0.99-0.99,2.6,0,3.59l2.37,2.37 c0.99,0.99,2.6,0.99,3.59,0c0.99-0.99,0.99-2.6,0-3.59L221.05,145.11z"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M332.68,84.48c-3.33,0-6.04-2.71-6.04-6.04s2.71-6.04,6.04-6.04s6.04,2.71,6.04,6.04 C338.72,81.77,336.01,84.48,332.68,84.48z M332.68,75.4c-1.68,0-3.05,1.37-3.05,3.04c0,1.68,1.37,3.05,3.05,3.05 s3.05-1.37,3.05-3.05C335.73,76.76,334.36,75.4,332.68,75.4z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M265.1,274.57c0,6.25,4.63,11.84,10.87,11.84h116.46c6.24,0,11.51-5.59,11.51-11.84V113.35 c0-6.25-5.26-11.42-11.51-11.42H275.97c-6.24,0-10.87,5.17-10.87,11.42V274.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 276.03,
    y: 115.44,
    className: "st24",
    width: 116.99,
    height: 141.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M326.68,271.36c0,4.16,3.36,7.52,7.52,7.52s7.52-3.36,7.52-7.52s-3.37-7.52-7.52-7.52 S326.68,267.2,326.68,271.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M336.75,159.3h-4.11l0,0v8.67l0,0h4.11l0,0c0.62,3.33,1.92,6.42,3.77,9.12l0,0l-2.91,2.9l0,0l6.13,6.13 l0,0l2.91-2.91l0,0c2.69,1.85,5.78,3.16,9.12,3.77l0,0v4.11l0,0h4.34h4.34l0,0v-4.11l0,0c3.34-0.61,6.43-1.92,9.12-3.77l0,0 l2.91,2.91l0,0l6.13-6.13l0,0l-2.91-2.9l0,0c1.85-2.69,3.16-5.78,3.77-9.12l0,0h4.11l0,0v-8.67l0,0h-4.11l0,0 c-0.62-3.34-1.92-6.43-3.77-9.12l0,0l2.91-2.91l0,0l-6.13-6.13l0,0l-2.91,2.91l0,0c-2.69-1.85-5.78-3.16-9.12-3.77l0,0v-4.11 l0,0h-4.34h-4.34l0,0v4.11l0,0c-3.33,0.61-6.43,1.92-9.12,3.77l0,0l-2.91-2.91l0,0l-6.13,6.13l0,0l2.91,2.91l0,0 C338.67,152.87,337.37,155.96,336.75,159.3L336.75,159.3z M347.05,159.24c1.75-5.65,7.16-9.36,13.08-9.36l0,0 c9.03,0,16.02,8.7,13.07,18.17c-1.76,5.64-7.16,9.35-13.07,9.35l0,0C351.1,177.39,344.11,168.71,347.05,159.24z M360.31,156.84 c3.97,0,7.2,3.22,7.2,7.2c0,3.97-3.22,7.2-7.2,7.2s-7.2-3.22-7.2-7.2S356.34,156.84,360.31,156.84z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M291.39,162.76h-3.05l0,0v6.44l0,0h3.05l0,0c0.46,2.47,1.43,4.77,2.8,6.77l0,0l-2.16,2.16l0,0l4.55,4.55 l0,0l2.16-2.16l0,0c2,1.37,4.29,2.35,6.77,2.8l0,0v3.05l0,0h3.22h3.22l0,0v-3.05l0,0c2.48-0.46,4.77-1.43,6.77-2.8l0,0 l2.16,2.16l0,0l4.55-4.55l0,0l-2.16-2.16l0,0c1.37-2,2.34-4.29,2.8-6.77l0,0h3.05l0,0v-6.44l0,0h-3.05l0,0 c-0.46-2.48-1.43-4.77-2.8-6.77l0,0l2.16-2.16l0,0l-4.55-4.55l0,0l-2.16,2.16l0,0c-2-1.37-4.29-2.35-6.77-2.8l0,0v-3.05l0,0 h-3.22h-3.22l0,0v3.05l0,0c-2.47,0.46-4.77,1.43-6.77,2.8l0,0l-2.16-2.16l0,0l-4.55,4.55l0,0l2.16,2.16l0,0 C292.82,157.99,291.85,160.28,291.39,162.76L291.39,162.76z M299.03,162.72c1.3-4.19,5.32-6.95,9.71-6.95l0,0 c6.7,0,11.89,6.46,9.7,13.48c-1.31,4.18-5.32,6.94-9.7,6.94l0,0C302.04,176.19,296.85,169.74,299.03,162.72z M308.88,160.93 c2.95,0,5.34,2.39,5.34,5.34s-2.39,5.34-5.34,5.34c-2.95,0-5.34-2.39-5.34-5.34S305.93,160.93,308.88,160.93z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M303.93,213.23l-4.38,0.67l0,0l1.42,9.24l0,0l4.38-0.67l0,0c1.2,3.45,3.1,6.53,5.51,9.09l0,0l-2.62,3.57 l0,0l7.54,5.53l0,0l2.62-3.57l0,0c3.17,1.53,6.68,2.42,10.33,2.53l0,0l0.67,4.38l0,0l4.62-0.71l4.62-0.71l0,0l-0.67-4.38l0,0 c3.45-1.2,6.53-3.1,9.09-5.51l0,0l3.57,2.62l0,0l5.53-7.54l0,0l-3.57-2.62l0,0c1.53-3.17,2.42-6.67,2.53-10.33l0,0l4.38-0.67 l0,0l-1.42-9.24l0,0l-4.38,0.67l0,0c-1.2-3.45-3.1-6.53-5.51-9.09l0,0l2.62-3.57l0,0l-7.54-5.53l0,0l-2.62,3.57l0,0 c-3.17-1.53-6.67-2.42-10.33-2.53l0,0l-0.67-4.38l0,0l-4.62,0.71l-4.62,0.71l0,0l0.67,4.38l0,0c-3.45,1.2-6.53,3.1-9.09,5.51 l0,0l-3.57-2.62l0,0l-5.53,7.54l0,0l3.57,2.62l0,0C304.93,206.07,304.04,209.57,303.93,213.23L303.93,213.23z M314.89,211.48 c0.94-6.3,6.1-11.14,12.39-12.11l0,0c9.61-1.48,18.49,6.64,16.89,17.21c-0.95,6.29-6.1,11.13-12.39,12.09l0,0 C322.18,230.15,313.31,222.05,314.89,211.48z M328.62,206.74c4.23-0.65,8.19,2.25,8.84,6.49c0.65,4.23-2.25,8.19-6.49,8.84 c-4.23,0.65-8.19-2.25-8.84-6.49C321.48,211.36,324.39,207.4,328.62,206.74z"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M452.11,134.7c-3.19-5.67-9.26-9.5-16.23-9.5c-10.29,0-18.63,8.34-18.63,18.63c0,0.31,0.03,0.62,0.05,0.93 c-5.01,0.61-8.93,4.91-8.93,10.08c0,5.59,4.57,10.16,10.16,10.16h20.32c0.52,0,1.02-0.05,1.52-0.13c0.61,0.08,1.23,0.13,1.87,0.13 h7.62c8.38,0,15.24-6.86,15.24-15.24C465.1,142.14,459.43,135.81,452.11,134.7z"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M195.57,137.93H99.78c-2.47,0-4.49,2.02-4.49,4.49v39.43c0,2.47,2.02,4.49,4.49,4.49h4.6v6.54l13.47-6.54 h77.72c2.47,0,4.49-2.02,4.49-4.49v-39.43C200.06,139.95,198.04,137.93,195.57,137.93z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 105.54,
    y: 145.42,
    className: "st12",
    width: 84.9,
    height: 8.04
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 105.54,
    y: 161.33,
    className: "st12",
    width: 84.9,
    height: 8.04
  }))))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "71.36,214.18 87.67,206.49 95.82,228.2 80.65,234.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "4.55,238.22 14.93,259.42 27.11,254.25 49.21,295.56 58.57,291.83 39.12,248.34 93.57,249.17  67.69,181.21 31.03,223.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "89.23,192.76 88.55,159.1 100.79,161  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "104.66,232.46 126.71,256.47 133.89,250.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "109.04,207.07 138.85,193.13 142.01,203.41  "
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M502.91,237.24h-12.69c0.45,2.2,0.69,4.48,0.69,6.82c0,18.83-15.26,34.09-34.09,34.09 s-34.09-15.26-34.09-34.09s15.26-34.09,34.09-34.09c4.32,0,8.46,0.8,12.26,2.27V199.1c-3.91-1.07-8.02-1.63-12.26-1.63 c-25.74,0-46.59,20.86-46.59,46.59c0,25.74,20.86,46.59,46.59,46.59c25.73,0,46.59-20.86,46.59-46.59 C503.4,241.75,503.24,239.47,502.91,237.24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M507.45,231.31h-12.69c-2.33-11.48-10.43-20.87-21.14-25v-13.14C491.27,197.97,504.75,212.89,507.45,231.31z "
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 450.999 253.846)",
    className: "st20 st29 st30"
  }, "25")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 434.8588 253.846)",
    className: "st20 st29 st30"
  }, "\u066A")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetmarketing);
export default __webpack_public_path__ + "static/media/internetmarketing.999420826022e325de86d41d57b7246a.svg";
export { ForwardRef as ReactComponent };